import React, { useRef, useState } from "react";
import Style from "./AllDeliveryRequestTable.module.scss";
import { Button, Input, Space, Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { separate } from './../../../../Utils/SeprateNumber/SeprateThreeNumber';
import moment from "moment-jalaali";

const AllDeliveyRequestTable = ({ modalHandler, data }) => {
  const searchInput = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            پاکسازی
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const columns = [
    {
      title: "شماره",
      dataIndex: "id",
      key: "id",
      ...getColumnSearchProps("id", "شماره درخواست"),
    },
    {
      title: "نام پیک",
      dataIndex: "driver_name",
      key: "driver_name",
      ...getColumnSearchProps("driver_name", "نام پیک"),
      render: (text) =>text??<p style={{color:"orangered"}}>"در انتظار تایید راننده"</p>
    },
    {
      title: "شماره پیک",
      dataIndex: "driver_phone",
      key: "driver_phone",
      ...getColumnSearchProps("driver_phone", "شماره پیک"),
      render: (text) =>text??<p style={{color:"orangered"}}>"در انتظار تایید راننده"</p>
    },
    {
      title: "نام درخواست دهنده",
      dataIndex: "requested_user",
      key: "requested_user",
      ...getColumnSearchProps("requested_user", "نام درخواست دهنده"),
    },
    {
      title: "شماره درخواست دهنده",
      dataIndex: "requested_user_phone",
      key: "requested_user_phone",
      ...getColumnSearchProps("requested_user_phone", "شماره درخواست دهنده"),
    },
    {
      title: "هزینه (تومان)",
      dataIndex: "delivery",
      key: "delivery",
      ...getColumnSearchProps("delivery", "هزینه"),
      render: (text) =><p style={{color:"green"}}>{separate(text)}</p>
    },
    {
      title: "زمان درخواست",
      dataIndex: "request_date",
      key: "request_date",
      render:(text)=>moment.unix(parseInt(text)).format("jYYYY/jM/jD----hh:mm:ss a")
    },
    {
      title: "وضعیت",
      dataIndex: "status",
      key: "status",
      ...getColumnSearchProps("status", "وضعیت"),
      render: (text) =>
        text === "0" ? (
          <p style={{ color: "orange" }}>منتظر تایید پیک</p>
        ) : text === "1" ? (
          <p style={{ color: "blue" }}>پیک در مسیر مبدأ</p>
        ) : text === "2" ? (
          <p style={{ color: "blue" }}>پیک در مبدأ است!</p>
        ) : text === "3" ? (
          <p style={{ color: "blue" }}>در مسیر مقصد!</p>
        ) : text === "4" ? (
          <p style={{ color: "green" }}>اتمام</p>
        ) : text === "-2" ? (
          <p style={{ color: "red" }}> درخواست لغو شده</p>
        ) : text === "-1" ? (
          <p style={{ color: "red" }}> توسط پیک کنسل شد! </p>
        ) : null,
    },

    {
      title: "عملیات",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div className={Style.btnHolder}>
          <button
            onClick={() => modalHandler(record)}
            className={Style.deleteBtn}
          >
            جزئیات درخواست
          </button>
        </div>
      ),
    },
  ];
  return (
    <div style={{ width: "100%" }}>
      <Table
        pagination={{ pageSize: 8 }}
        columns={columns}
        dataSource={data}
      />
    </div>
  );
};

export default AllDeliveyRequestTable;
